import { useContext, useState } from "react";
import { useToast } from "../ToastContext";
import { LoadingContext } from "../LoadingContext";
import {
  createUsersGat,
  getUsersByIdGat,
  updateUsersGat,
  validateEmailGat,
} from "../../gateways/UsersGateway";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import { UserToken } from "./useAuth";
import { fetchIp } from "../../utils/fetchIp";

export interface UserType {
  name: string;
  email: string;
  password: string;
  nationalRegisterCode: string;
  phone: string;
  address: UserAddressType;
  [key: string]: any;
}

export interface UserAddressType {
  street: string;
  addtionalData: string;
  district: string;
  city: string;
  state: string;
  postalCode: string;
  country: string;
}

export default function useUserType() {
  const showToast = useToast();
  const { setLoading } = useContext(LoadingContext);
  const [pageCount, setPageCount] = useState<number>(0);
  const [ipUser, setIpUser] = useState<string>("");
  const navigate = useNavigate();
  const [formValuesUsers, setFormValuesUsers] = useState<UserType>({
    name: "",
    email: "",
    password: "",
    nationalRegisterCode: "",
    phone: "",
    address: {
      street: "",
      addtionalData: "",
      district: "",
      city: "",
      state: "",
      postalCode: "",
      country: "",
    },
  });

  const createUsers = async (user: UserType) => {
    try {
      setLoading(true);

      user.nationalRegisterCode = user.nationalRegisterCode?.replace(
        /[^\d]/g,
        ""
      );

      const result = await createUsersGat(user);
      if (result) {
        showToast("success", "Sucesso ao cadastrar");

        navigate("/auth/activeuserinfo");

        setLoading(false);
      }
    } catch (error: any) {
      console.log(error);
      showToast(
        "error",
        error?.response?.data?.error?.message || "Erro ao cadastrar"
      );
      setLoading(false);
    }
  };

  const updateUsers = async () => {
    try {
      setLoading(true);

      const result = await updateUsersGat(formValuesUsers);
      if (result) {
        showToast("success", "Sucesso ao atualizar");

        setLoading(false);
      }
    } catch (error: any) {
      console.log(error);
      showToast("error", "Erro ao atualizar");
      setLoading(false);
    }
  };

  const validateEmail = async (email: string) => {
    try {
      const result = await validateEmailGat(email);
      if (result) {
        return result.data;
      }
    } catch (error: any) {
      console.log(error);
      showToast("error", "Erro ao atualizar");
    }
  };

  const getUsersById = async (UserId: string, suppressErrorToast = false) => {
    try {
      setLoading(true);
      if (UserId) {
        const result = await getUsersByIdGat(UserId);
        if (result) {
          setFormValuesUsers(result.data);
        }
      }
    } catch (error: any) {
      console.log(error);
      if (!suppressErrorToast) {
        showToast("error", "Erro ao carregar dados do usuário");
      }
    } finally {
      setLoading(false);
    }
  };
  
  const getUserIp = async () => {
    try {
      const result = await fetchIp();
      setIpUser(result || "");
    } catch (error: any) {
      console.log(error);
      showToast("error", "Erro ao carregar dados do usuário");
    }
  };

  return {
    createUsers,
    setPageCount,
    pageCount,
    formValuesUsers,
    setFormValuesUsers,
    getUsersById,
    updateUsers,
    getUserIp,
    ipUser,
    validateEmail,
  };
}
